import React from 'react'
import './VisualGrid.scss'
import { useDashboardDomainContext } from "../../DashboardDomainProvider";
import VisualCreationDialog from '../dialogs/VisualCreationDialog.jsx';
import { UnpublishedMessage, WelcomeMessage, NoVisualsMessage } from './messages';
import { VisualGridBody } from './subcomponents/VisualGridBody';
import { VisualExportDialog } from '../dialogs/VisualExportDialog.jsx';
import FullscreenOverlay from './subcomponents/FullscreenOverlay.jsx';
import { useFullscreen } from '../../contexts/FullScreenContext.js';
import { useCorePermissions } from 'spark-core-dx/hooks';

export const VisualGrid = () => {
    const { hasDashboards, isViewMode, isTabPublished, isTabEmpty, isOwner } = useDashboardDomainContext();

    const { isFullscreen, fullscreenCard } = useFullscreen();

    const { canEdit } = useCorePermissions();

    return (
        <div className='visual-grid-container'>
            {isViewMode && isFullscreen && <FullscreenOverlay isFullscreen={isFullscreen} card={fullscreenCard} />}
            {isViewMode && <VisualExportDialog />}
            {!isViewMode && canEdit('Dashboard') && <VisualCreationDialog />}
            {(isViewMode && !hasDashboards) && <WelcomeMessage />}
            {isOwner && (isViewMode && hasDashboards && !isTabPublished) && <UnpublishedMessage />}
            {(isViewMode && hasDashboards && isTabPublished && isTabEmpty) && <NoVisualsMessage />}
            {(!isViewMode || (isViewMode && hasDashboards && isTabPublished && !isTabEmpty)) && <VisualGridBody />}
        </div>
    )
}
